<template>
    <div
        class="palette-bar"
        v-show="store.state.currentScreen === 'my-phaser-container'"
    >
        <div class="swatch-area">
            <div
                v-for="(swatch, i) in store.state.swatches" :key="i"
                @dragenter="onDrop($event, i)"
                @dragover.prevent
                class="my-swatch-entry"
                :style="getSwatchStyle()"
            >
                <img
                    :title="swatch.description"
                    :src="swatch.rt?.canvas?.toDataURL()"
                    :class="swatch.selected ? 'selected-swatch' : ''"
                    @pointerdown="clickOnSwatch(swatch)"
                    draggable
                    @dragstart="startDrag($event, swatch)"
                >
            </div>
            <Icon
                class="icon-block"
                icon="add"
                @pointerdown="newSwatch"
                :title="t('new swatch','New swatch')"
            />
        </div>
        <div class="active-style-area">
            <img
                v-if="activeSwatchSource"
                :title="t('active swatch','Active Swatch')"
                :src="activeSwatchSource"
                class="active-style"
            >
        </div>
    </div>
</template>

<script>
import { palette } from '../myapp/src/palette';
import { myInput } from '../myapp/src/input';
import { isIOS } from '../myapp/src/core/environment';
import { modes } from '../myapp/src/modes';
import { historie } from '../myapp/src/history';
import Icon from '../components/Icon.vue';

export default {
    data() {
        return {
            swatchCopy: [],
            draggingSwatchID: null,
        }
    },
    components: { Icon },
    methods: {
        getSwatchStyle() {
            const height = this.store.state.plasticMode ? 38 : 32;
            return `height: ${height}px;`;
        },
        newSwatch() {
            modes.start('editSwatch');

            const prefix = this.store.state.libraryShape === 'cylinder' ? 'cylinder_' : '';

            const swatch = {
                fillColor: 4243391,
                description: '',
                finishName: this.store.state.plasticMode ?
                    'plastic' : `${prefix}matte`,
                inner: 'opaque',
                secondColor: null,
                isNew: true,
                hasBeadsOnCanvas: () => false
            };
            b3.ee.emit('editSwatch', swatch);
            this.store.mySet('showingModal', 'swatch-edit');
            myInput.enableTyping();

        },
        clickOnSwatch(s) {
            palette.clickOnSwatch(s);
        },
        startDrag(evt, item) {
            if (isIOS) return;
            evt.dataTransfer.dropEffect = 'move';
            evt.dataTransfer.effectAllowed = 'move';
            this.draggingSwatchID = item.id;
            this.swatchCopy = this.store.state.swatches.slice();
        },
        onDrop(evt, i) {
            if (isIOS) return;
            const itemID = this.draggingSwatchID;
            evt.dataTransfer.dropEffect = 'move';
            const source = this.store.state.swatches.find(item => item.id === Number(itemID));
            if (!source) return;

            const cutLocation = this.store.state.swatches.indexOf(source);
            const pasteLocation = i;

            this.cutPaste(cutLocation, pasteLocation, source);
        },
        cutPaste(cutLocation, pasteLocation, source) {
            this.swatchCopy.splice(cutLocation, 1);
            this.swatchCopy.splice(pasteLocation, 0, source);

            this.store.mySet('swatches', this.swatchCopy);
            game.input.activePointer.isDown = false; // fix bug where phaser things we're still holding the mouse down
            historie.addAction();
        },
    },
    computed: {
        activeSwatch: function () {
            return this.store.state.swatches.find(s => s.selected);
        },
        activeSwatchSource: function () {
            return this.store.state.beadSoupActive ?
                require(`../../public/images/soup.png`):
                this.activeSwatch?.rt?.canvas?.toDataURL();
        }
    }
}

</script>

<style lang="scss">
@import '../assets/colors.scss';

.palette-bar {
    height: calc(100% - 48px);
    max-height: 965px;
    position: absolute;
    z-index: 1;
    top: 48px;
    left: 0px;
    background-color: $off_white;

    .swatch-area {
        padding: 12px 0px 12px 15px;
        height: calc(100% - 100px);
        width: 100%;
        overflow-y: auto;

        .my-swatch-entry {
            user-select: none;
        }

        .selected-swatch {
            border: 2px solid $highlight;
            padding: 1px;
            position: relative;
            left: -3px;
            top: -3px;
        }
        .icon-block {
            background-color: $b_theme;
            color: white;
            width: 36px;
            text-align: center;
            padding: 2px 0;
            &:hover {
                background-color: $b_theme_hover;
                cursor: pointer;
            }
        }
    }

    .active-style-area {
        user-select: none;
        .active-style {
            width: 55px;
            padding: 15px 6px;
        }
    }
}

</style>